import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";


const ConfirmationModal = ({ title,body, modal, buttons, setModal }) => {

    const toggle = () => setModal(!modal);

    return (
        <div>
            <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                   {title}
                </ModalHeader>
                <ModalBody>
                    {body}
                </ModalBody>
                <ModalFooter>
                    {buttons.map((button) => {
                        return (
                            <Button
                              className={button.className}
                              onClick={() => button.onclick()}>
                              <i className={button.icon} aria-hidden="false" />{` ${button.title}`}
                            </Button>

                        )
                    })}
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default ConfirmationModal;